import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const query = gql`
mutation updateMyPhoneNumber($phoneNumber: String) {
    updateMyPhoneNumber(phoneNumber: $phoneNumber) 
},
`;

export default async function updateMyPhoneNumber(phoneNumber?: string) {
    const variables: OperationVariables = {
        phoneNumber: phoneNumber || null,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
